import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-white overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/26f58914503d6a4620259abfbbe83181.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      <div className="absolute inset-0 bg-[#7FB3FF]/40"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-32 w-full">
        <div className="flex flex-col items-center text-center space-y-8 max-w-3xl mx-auto">
          <div className="space-y-6">
            <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight">
              The Broker
              <br />
              <span className="text-[#3D8BFF]">Marketplace</span>
            </h1>

            {/* Financing Banner */}
            <div className="inline-flex items-center gap-3 bg-white/95 backdrop-blur-sm border border-[#A9C9FF] px-6 py-3 rounded-full mb-10 shadow-lg">
              <div className="w-8 h-8 flex items-center justify-center bg-[#A9C9FF] rounded-full flex-shrink-0">
                <i className="ri-money-dollar-circle-fill text-[#2F6FE4] text-lg"></i>
              </div>
              <span className="text-[#555555] font-bold text-base tracking-wide">
                💰 Financing Available — Up to <span className="text-[#3D8BFF]">$100,000</span>
              </span>
            </div>

            <h2 className="text-3xl lg:text-4xl text-white font-medium">
              Wholesale Trade Lines and Done For You <span className="text-[#3D8BFF]">Business Credit Services</span> for Brokers
            </h2>
            <p className="text-lg text-white/90 leading-relaxed max-w-xl mx-auto">
              Sell business credit services without managing fulfillment. Access wholesale trade lines, backend processing, and fulfillment support.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/broker-signup"
              className="inline-flex items-center gap-3 bg-white text-[#2F6FE4] px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-user-add-line text-xl"></i>
              Become a Broker
            </Link>
            
            <Link
              to="/services"
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-service-line text-xl"></i>
              View Services
            </Link>
            
            <a
              href="https://calendar.app.google/gHXojhhUdSU7koyR7"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer group relative"
              title="Speak with our team if you have questions before becoming a broker."
            >
              <i className="ri-calendar-line text-xl"></i>
              Schedule Intro Call
            </a>
          </div>

          {/* Fund Me Button */}
          <div className="flex justify-center">
            <a
              href="https://app.flexxbuy.com/fast-funding-capital-llc/apply/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-green-600 transition-all hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-funds-line text-xl"></i>
              Fund Me
            </a>
          </div>
        </div>

        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
          <div className="w-64 h-0.5 bg-[#3D8BFF] mb-4"></div>
          <i className="ri-arrow-down-line text-[#3D8BFF] text-2xl animate-bounce"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
